import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import MultiSizeFieldArray, { sizesForSubmit } from "../../common/multiSizeFieldArray";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../common/breadcrumbs";
import * as categoryServices from "../../services/category.services";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { Tooltip, Whisper, Loader } from "rsuite";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../common/customeditor";



const CategoryAdd = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation()
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [initialValues, setInitialValues] = useState({
    title: "",
    title_ja: "",
    name: "",
    slug: "",
    description: "",
    short_description_ja: "",
    meta_tags: "",
    meta_keyword: "",
    richtext: "",
    title_de: "",
    richtext_ja: "",
    files: "",
    type: "outfit",
    sizes: [{ title: "" }],
  });



  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard/1" },
    { title: t("link_category"), url: "/admin/category/list/1" },
    { title: t("link_add"), url: "" },
  ];




  useEffect(() => {
    setInitialValues({
      title: state && state?.title ? state?.title : "",
      title_ja: state && state?.title_ja ? state?.title_ja : "",
      slug: state && state?.slug ? state?.slug : "",
      status: state && state?.status ? state.status : "",
      menu_location: state && state?.menu_location ? state.menu_location : "",
      description:
        state && state?.description ? state?.description : "",
      short_description_ja:
        state && state?.short_description_ja ? state?.short_description_ja : "",
      richtext: state && state?.description ? state?.description : "",
      richtext_ja: state && state?.richtext_ja ? state?.richtext_ja : "",
      files: "",
      type: state && state?.type ? state?.type : "outfit",
      sizes: [{ title: "" }],
    });
    setDataLoaded(true);
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validateOnBlur={false}
          validationSchema={Yup.object().shape({
            title: Yup.string()
              .required(t("label_title_error"))
              .max(INPUT_LENGTH_500, t("validation_err_reached_maximum_length")),
            description: Yup.string()
              .required(t("label_description_error")),
            type: Yup.string()
              .required(t("label_type_error")),
            files: Yup.mixed()
              .required(t("label_image_error"))
              .test("fileType", t("label_image_format_error"), (value) => {
                if (!value) return false;
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return supportedFormats.includes(value.type);
              }),
            sizes: Yup.array().of(
              Yup.object().shape({
                title: Yup.string().max(
                  INPUT_LENGTH_500,
                  t("validation_err_reached_maximum_length")
                ),
              })
            ).test(
              "at-least-one-size",
              t("validation_err_size_required"),
              (sizes) => Array.isArray(sizes) && sizes.some((s) => s?.title?.trim())
            ),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitted(true);
            globalLoader(true);
            console.log(values);
            let formData = new FormData();
            formData.append("title", values.title);
            formData.append("description", values.description);
            formData.append("type", values.type);
            formData.append("sizes", JSON.stringify(sizesForSubmit(values.sizes)));
            formData.append("image", values.files);
            categoryServices
              .Add(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  setTimeout(() => {
                    resetForm({ values: "" });
                    globalLoader(false);
                    navigate(`/admin/category/list/1`);
                  }, 1000);
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  setSubmitted(false);
                  globalLoader(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("add_category")}</h6>
                      </div>
                      <div className="row row-sm">
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="title" className="text-left d-flex">
                            {t("list_heading_title")}:<span className="requirestar">*</span>
                            {/* <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  {t("admin.pages.tooltip_page_title")}
                                </Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper> */}
                          </label>
                          <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("category_title_placeholder")} />
                          <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                        </div>
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="description" className="text-left d-flex">
                            {t("label_description")}:<span className="requirestar">*</span>
                          </label>
                          <textarea name="description" type="text" onChange={handleChange} onBlur={handleBlur} value={values.description} className="form-control" placeholder={t("faq_description_placeholder")} rows="5" />
                          <span className="text-danger d-flex text-left">{errors.description && touched.description && t(errors.description)}</span>
                        </div>
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="type" className="text-left d-flex">
                            {t("label_type")}:<span className="requirestar">*</span>
                          </label>
                          <select name="type" id="type" onChange={handleChange} onBlur={handleBlur} value={values.type} className="form-control">
                            <option value="outfit">{t("label_outfit")}</option>
                            <option value="item">{t("label_item")}</option>
                          </select>
                          <span className="text-danger d-flex text-left">{errors.type && touched.type && t(errors.type)}</span>
                        </div>
                        <MultiSizeFieldArray values={values} errors={errors} name="sizes" />
                        <div className="col-lg-12 text-center form-group">
                          <label htmlFor="files" className="text-left d-flex">
                            {t("label_image")}:<span className="requirestar">*</span>
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Recommended Size (1920x887)</Tooltip>
                              }
                            >
                              <span className="field-more-info mt-1 ms-1 cp">
                                ?
                              </span>
                            </Whisper>
                          </label>
                          <input
                            className="form-control imgInput"
                            id="files"
                            name="files"
                            accept="image/*"
                            type="file"
                            onChange={(event) => {
                              setFieldValue(
                                "files",
                                event.currentTarget.files[0] || ""
                              );
                              event.currentTarget.files.length === 1
                                ? setPreviewImage(
                                  URL.createObjectURL(
                                    event.currentTarget.files[0]
                                  )
                                )
                                : setPreviewImage("");
                            }}
                          />
                          <span
                            className="text-danger d-flex text-left"
                            id="errortext"
                          >
                            {errors.files && touched.files && errors.files}
                          </span>
                        </div>
                        {previewimage ? (
                          <ul className="question-image-preview questions-ul">
                            <li className="pr_img_box">
                              <img
                                src={previewimage}
                                style={{ height: "100px" }}
                                alt={t("category-image")}
                              />
                              <div className="img_options">
                                <button type="button" className="text-danger"
                                  onClick={() => {
                                    setPreviewImage("");
                                    setFieldValue("files", "");
                                    document.getElementById("files").value = ""
                                  }}>
                                  <i className="ri-delete-bin-6-fill"></i>
                                </button>
                              </div>
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        <div className="">
                          <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                            {t("btn_submit")}
                          </button>
                          <button className="btn ripple btn-secondary" type="button" disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                            {t("btn_cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <></>
      )}
    </>
  );
};

export default CategoryAdd;
